var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hide,
          expression: "hide"
        }
      ]
    },
    [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              _vm.status = true
            }
          }
        },
        [
          _c("img", {
            staticClass: "img-thumbnail",
            attrs: { width: "100px", height: "auto", src: _vm.thumbnail }
          })
        ]
      ),
      _vm._v(" "),
      _vm.showToolbar
        ? _c("div", [
            _c("a", { attrs: { href: _vm.original, download: "" } }, [
              _c("i", { staticClass: "fa fa-download" }),
              _vm._v(" İndir\n        ")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.rotate.apply(null, arguments)
                  }
                }
              },
              [
                _vm.isRotating
                  ? _c("span", [
                      _c("i", { staticClass: "fa fa-spinner" }),
                      _vm._v(" Döndürülüyor\n            ")
                    ])
                  : _c("span", [
                      _c("i", { staticClass: "fa fa-repeat" }),
                      _vm._v(" Döndür\n            ")
                    ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.status
        ? _c(
            "div",
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modal-mask centered-modal" }, [
                  _c("div", { staticClass: "modal-wrapper" }, [
                    _c("div", { staticClass: "modal-dialog" }, [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: { click: _vm.hide }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("h4", { staticClass: "modal-title" }, [
                            _vm._v("Resim")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-body" },
                          [
                            _c("v-zoomer", [
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: _vm.original }
                              })
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-220219ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-220219ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/image-modal.vue
// module id = 72
// module chunks = 0